<template>
  <div>
    <header>
      <div class="container">
        <router-link to="/">
          <img
            src="@/assets/images/slm_logo.svg"
            alt="skroutz last mile logo"
          />
        </router-link>
        <div style="display: flex;">
          <b-button
            v-b-popover.hover.bottom="$t('navbar.menu')"
            variant="outline"
            @click="isInfoDetailsOpen = !isInfoDetailsOpen"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-list"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </b-button>
        </div>
      </div>
    </header>

    <div class="login-container">
      <section
        v-show="isInfoDetailsOpen || isBigScreen"
        class="info-details"
        :class="isInfoDetailsOpen && 'opened'"
      >
        <div class="left-container">
          <div>
            <div class="header-container">
              <router-link to="/">
                <img src="../assets/images/hat.svg" alt="hat" width="40" />
                <img
                  src="../assets/images/slm_logo.svg"
                  alt="logo"
                  width="140"
                />
              </router-link>
            </div>
            <h4>Last Mile Recruitment Page</h4>
            <div class="specs">
              <div>
                <div class="line">
                  <img
                    src="../assets/images/supervisor_account.svg"
                    alt="memmbers"
                    width="30"
                  />
                  <span>150+ {{ $t('landingPage.info.couriers') }}</span>
                </div>
                <div class="line">
                  <img
                    src="../assets/images/directions_car.svg"
                    alt="fleet"
                    width="30"
                  />
                  <span>200+ {{ $t('landingPage.info.vehicles') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-down">
            <div class="contact-btn" @click="trackContact">
              <a href="mailto:recruiters@skroutzdelivery.gr">{{
                $t('common.contactButton')
              }}</a>
            </div>
          </div>
        </div>
        <b-nav-form v-if="showsLogout" right style="position: absolute;">
          <b-button
            v-b-popover.hover.bottom="$t('navbar.logoutButton')"
            variant="outline"
            @click="logout"
          >
            <b-icon-arrow-right-circle></b-icon-arrow-right-circle>
          </b-button>
        </b-nav-form>
      </section>
      <section class="page-details" :class="showsLogout && 'interview'">
        <div class="clouds">
          <img src="../assets/images/cloud.svg" alt="" width="60" />
          <img src="../assets/images/cloud.svg" alt="" width="84" />
          <img src="../assets/images/cloud.svg" alt="" width="50" />
          <img src="../assets/images/cloud.svg" alt="" width="42" />
          <img src="../assets/images/cloud.svg" alt="" width="53" />
        </div>
        <div class="screen-panel">
          <slot></slot>
        </div>
      </section>
    </div>

    <page-footer />
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';

import PageFooter from '@/components/PageFooter.vue';

export default {
  name: 'Landing',
  components: {
    PageFooter
  },
  props: {
    showsLogout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isInfoDetailsOpen: false,
      isBigScreen: window.matchMedia('(min-width: 734px)').matches
    };
  },
  mounted() {
    window.addEventListener('resize', this.isMatchBigScreen);
  },
  destroyed() {
    window.removeEventListener('resize', this.isMatchBigScreen);
  },
  methods: {
    trackContact() {
      window.fbq('track', 'Contact');
      firebase.analytics().logEvent('contact');
    },
    async logout() {
      const isModalConfirmOpen = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t('interviewPage.logout.message'),
        {
          title: this.$i18n.t('interviewPage.logout.title'),
          okTitle: this.$i18n.t('generic.yes'),
          okVariant: 'danger',
          cancelTitle: this.$i18n.t('generic.no')
        }
      );

      if (isModalConfirmOpen) {
        await firebase.auth().signOut();
        this.$router.push({ name: 'Welcome' });
      }
    },
    isMatchBigScreen() {
      this.isBigScreen = window.matchMedia('(min-width: 734px)').matches;
    }
  }
};
</script>

<style lang="scss" scoped>
$white: #fff;
$white8: rgb(255, 255, 255, 0.8);
$orange: #f68b24;
$orange9: rgba(246, 139, 36, 0.9);
$orange45: rgba(246, 139, 36, 0.45);
$black: #363636;

header {
  display: none;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

.login-container {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

.info-details {
  width: 40%;
  display: flex;
  justify-content: flex-end;
  background: url('../assets/images/bg_blank.svg'),
    linear-gradient(270deg, $orange9 20%, #fff 90%);
  background-position: bottom 0% right 0%, 0% 0%;
  background-repeat: no-repeat;
  background-size: contain;

  .left-container {
    max-width: 300px;
    width: 100%;
    margin-right: 2rem;
    padding: 3rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 3rem;

      img:first-child {
        margin-right: 2rem;
      }
    }

    h4 {
      padding: 0 3rem;
      margin-bottom: 2rem;
      text-align: center;
    }

    .specs {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      margin-bottom: 3rem;

      .line {
        display: flex;
        align-items: center;

        span {
          margin-left: 1rem;
          font-weight: bold;
        }
      }
    }

    .contact-btn {
      display: flex;
      justify-content: center;
      margin-top: 1rem;

      a {
        width: 160px;
        padding: 12px 28px;
        border-radius: 6px;
        border: 1px solid $orange;
        background: $white;
        color: $orange;
        text-align: center;
        font-weight: bold;
        text-decoration: unset;

        &:hover {
          border: 1px solid $white;
          background: $orange9;
          color: $white;
        }
      }
    }
  }
}
.page-details {
  position: relative;
  width: 60%;
  background: $orange45;

  .clouds {
    img {
      &:nth-child(1) {
        position: absolute;
        top: 5%;
        left: 20%;
        opacity: 0.5;
      }
      &:nth-child(2) {
        position: absolute;
        top: 14%;
        left: 80%;
      }
      &:nth-child(3) {
        position: absolute;
        top: 50%;
        left: 12%;
        opacity: 0.7;
      }
      &:nth-child(4) {
        position: absolute;
        top: 93%;
        left: 52%;
        opacity: 0.45;
      }
      &:nth-child(5) {
        position: absolute;
        top: 80%;
        left: 78%;
      }
    }
  }

  .screen-panel {
    z-index: 10;
    width: 100%;
    height: 100%;
    padding: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .form-container {
      width: 100%;
      background: $white8;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      min-width: 300px;
      max-width: 600px;
      z-index: 10;
      overflow: hidden;

      h4 {
        background: $orange9;
        padding: 1rem 2rem;
        text-align: center;
        color: $white;
      }
    }
  }
}

.flex-down {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 733px) {
  header {
    display: block;
    background: $white;
    border-bottom: 1px solid #dcdcdc;
    padding: 16px 0;
    z-index: 11;
  }
  header .container {
    width: 94%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      cursor: pointer;
    }
  }

  .info-details {
    position: fixed;
    z-index: 11;
    min-height: 400px;
    width: 0;

    &,
    .opened,
    .closed {
      width: 80%;
      height: 100%;

      animation-name: openPanel;
      animation-duration: 0.5s;
    }
  }
  .page-details {
    width: 100%;

    .screen-panel {
      min-height: 100%;
      padding-top: 80px;
      padding-bottom: 10px;
    }
  }

  @keyframes openPanel {
    from {
      width: 0;
    }
    to {
      width: 80%;
    }
  }
}
</style>
